<template>
  <div class="sjcj">
    <div class="card1">
      <div class="w1280">
        <div style="padding: 112px 0;">
          <div class="t11">数据采集</div>
          <div class="t22">
            拥有全球范围290+语言资源及100万众包团队，我们提供全面的数据定制采集服务，为您的AI部署提供高质量的数据支持
          </div>
          <div class="btn1" style="margin: 0 auto;" @click="go('/callMe')">详情咨询</div>
        </div>
      </div>
    </div>
    <div class="card2">
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 45%;">
            <div class="t1">图像数据采集</div>
            <div>
              具有全球多人种、特定场景及物体、特定语言及载体的采集能力，全方位支持您的图像采集需求
            </div>
            <div
              class="flexs"
              style="justify-content: left;margin-bottom: 48px;"
            >
              <div style="width: 50%;">
                <ul>
                  <li>多人种人像采集</li>
                  <li>情感图像采集</li>
                  <li>手势图像采集</li>
                  <li>动作图像采集</li>
                  <div>&nbsp;</div>
                  <li>街景图像采集</li>
                  <li>驾驶员采集</li>
                  <li>建筑物裂缝采集</li>
                  <li>扫地机器人视角采集</li>
                  <li>动物图像采集</li>
                </ul>
              </div>
              <div style="width: 50%;">
                <ul>
                  <li>多语言OCR图像采集</li>
                  <li>试卷/公式手写采集</li>
                  <li>收据/票据采集</li>
                  <li>书本/海报/杂志采集</li>
                  <div>&nbsp;</div>
                  <li>通用物体采集</li>
                  <li>特定情景采集</li>
                  <li>海外情景采集</li>
                  <li>3D人脸采集</li>
                  <li>3D物体采集</li>
                </ul>
              </div>
            </div>
            <div class="btn1" @click="go('/callMe')">
              项目咨询
              <i class="el-icon-right"></i>
            </div>
          </div>
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjfw/h1.webp"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjfw/h2.webp"
              alt=""
            />
          </div>
          <div style="width: 45%;">
            <div class="t1">视频数据采集</div>
            <div>
              具有多场景、多国家地点的采集能力，快速高效地响应您的数据需求
            </div>
            <div
              class="flexs"
              style="justify-content: left;margin-bottom: 48px;"
            >
              <div style="width: 50%;">
                <ul>
                  <li>多人种视频采集</li>
                  <li>面部动作视频采集</li>
                  <li>行人行为采集</li>
                  <li>老人跌倒视频采集</li>
                  <li>亲属人脸采集</li>
                </ul>
              </div>
              <div style="width: 50%;">
                <ul>
                  <li>自然天气视频采集</li>
                  <li>体育运动视频采集</li>
                  <li>儿童活动视频采集</li>
                  <li>动物视频采集</li>
                  <li>道路交通采集</li>
                </ul>
              </div>
            </div>
            <div class="btn1" @click="go('/callMe')">
              项目咨询
              <i class="el-icon-right"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 45%;">
            <div class="t1">文本数据采集</div>
            <div>
              可以为您提供英语、越南语、泰语、印尼语、阿拉伯语、葡萄牙语、意大利语等超过290种语言及方言的文本采集服务
            </div>
            <div
              class="flexs"
              style="justify-content: left;margin-bottom: 48px;"
            >
              <div style="width: 50%;">
                <ul>
                  <li>实体词采集</li>
                  <li>单轮/多轮对话语料采集</li>
                  <li>录音语料采集</li>
                  <li>指令词采集</li>
                  <li>多语言平行语料采集</li>
                </ul>
              </div>
              <div style="width: 50%;">
                <ul>
                  <li>医疗问答语料采集</li>
                  <li>舱内多语种指令词采集</li>
                  <li>学术领域语料采集</li>
                  <li>评论打分语料采集</li>
                </ul>
              </div>
            </div>
            <div class="btn1" @click="go('/callMe')">
              项目咨询
              <i class="el-icon-right"></i>
            </div>
          </div>
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjfw/h3.webp"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjfw/h4.webp"
              alt=""
            />
          </div>
          <div style="width: 45%;">
            <div class="t1">语音数据采集</div>
            <div>
              支持全球170+个地区的超过290种语言和方言，为您量身定制AI所需的语言数据
            </div>
            <div
              class="flexs"
              style="justify-content: left;margin-bottom: 48px;"
            >
              <div style="width: 50%;">
                <ul>
                  <li>中外文唤醒词采集</li>
                  <li>短音频单人自由说采集</li>
                  <li>自由对话采集</li>
                  <li>长音频采集</li>
                  <div>&nbsp;</div>
                  <li>声纹录音采集</li>
                  <li>歌曲录音采集</li>
                  <li>电话信道双人对话采集</li>
                  <li>手机录音采集</li>
                </ul>
              </div>
              <div style="width: 50%;">
                <ul>
                  <li>地方方言采集</li>
                  <li>英语语言多口音采集</li>
                  <li>小语种采集</li>
                  <li>TTS语音合成采集</li>
                  <div>&nbsp;</div>
                  <li>车载语音采集</li>
                  <li>动物叫声采集</li>
                  <li>婴儿啼哭采集</li>
                  <li>商务对话</li>
                </ul>
              </div>
            </div>
            <div class="btn1" @click="go('/callMe')">
              项目咨询
              <i class="el-icon-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card2">
      <div class="title">行业采集能力</div>
      <div class="slogan">
        英语、越南语、泰语、印尼语、阿拉伯语、葡萄牙语、意大利语等超过290种语言及方言
      </div>
      <div class="w1280" style="margin: 48px 128px;width: 1024px;">
        <div class="flexs" style="flex-wrap: wrap;">
          <div class="card-sx" v-for="(item, index) in cardList" :key="index">
            <img
              style="width: 500px;height: 192px;border-radius:8px 8px 0 0; object-fit: cover; object-position: top;"
              :src="item.img"
              alt=""
            />
            <div class="contents">
              <div class="t1">{{ item.title }}</div>
              <div
                v-for="(item1, index1) in item.textList"
                :key="index1"
                class="t2"
              >
                {{ item1.title }}<span class="t3">{{ item1.content }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card2">
      <div class="title">资源与工具</div>
      <div class="slogan">
        我们的资源优势体现在人员资源，软件支持，以及工具支持等方面
      </div>
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjfw/n1.webp"
              alt=""
            />
          </div>
          <div style="width: 45%;">
            <div class="t1">采集设备支持</div>
            <div
              class="flexs"
              style="justify-content: left;margin-bottom: 48px;"
            >
              <div style="width: 48%;margin-right: 4%;">
                <div style="color: #333;font-weight: bold;margin-bottom: 24px;">
                  语音采集
                </div>
                <ul style="margin-left: 32px;">
                  <li>
                    录音棚（人声/歌曲/大型乐队）：声卡，话放，调音台，监听音箱，监听耳机
                  </li>
                  <li>
                    麦克风（单通麦克风/麦克风阵列）：电容麦克风，电子管麦克风，动圈麦克风，领夹麦克风
                  </li>
                  <li>高保真录音设备</li>
                </ul>
              </div>
              <div style="width: 48%;">
                <div style="color: #333;font-weight: bold;margin-bottom: 24px;">
                  图像采集
                </div>
                <ul style="margin-left: 32px;">
                  <li>自研APP支持各类型号手机</li>
                  <li>IR, RGB相机，深度相机TOF</li>
                  <li>
                    激光雷达（道路），毫米波雷达（道路），双目相机（IR+RGB），鱼眼相机
                  </li>
                  <li>
                    3D-Faceware脸部动作捕捉，3D-眼动仪，3D-三维扫描仪（激光扫描仪，照相机扫描仪，手持扫描仪等）
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 45%;">
            <div class="t1">采集软件支持</div>
            <div
              class="flexs"
              style="justify-content: left;margin-bottom: 48px;"
            >
              <div style="width: 48%;margin-right: 4%;">
                <div style="color: #333;font-weight: bold;margin-bottom: 24px;">
                  采集&交付软件
                </div>
                <ul style="margin-left: 32px;">
                  <li>
                    Task：基本实现全类型数据采集，有利于全球众包进行采集整合
                  </li>
                  <li>
                    VOIP电话信道采集软件可满足16&8 K 采样率
                  </li>
                  <li>
                    zqLinx AI平台用于文本数据采集，以及音频、图像、和视频数据的质量检测、预识别、查重等
                  </li>
                </ul>
              </div>
              <div style="width: 48%;">
                <div style="color: #333;font-weight: bold;margin-bottom: 24px;">
                  数据处理软件
                </div>
                <ul style="margin-left: 32px;">
                  <li>
                    DAW（棚内音频编辑软件）
                  </li>
                  <li>
                    Adobe Audition
                  </li>
                  <li>Blender</li>
                  <li>自主研发录音桌面端工具</li>
                  <li>Meshlab</li>
                  <li>AI 算法辅助声纹比对工具</li>
                  <li>
                    项目交付通用工具组：包括文件批量重命名，批量改格式，音频格式转换，格式互转等
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjfw/n2.webp"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="card4">
      <div class="card4-t1">数据的隐私安全</div>
      <div class="flexs" style="flex-wrap: wrap;">
        <div class="item-card" v-for="(item, index) in cardList1" :key="index">
          <img style="width: 48px;" :src="item.img" alt="" />
          <div style="font-size: 20px;margin:20px 0;color: #000;">
            {{ item.name }}
          </div>
          <ul>
            <li
              style="font-size: 16px;line-height: 1.5;color: #4b4f54;"
              v-for="(item1, index1) in item.list"
              :key="index1"
            >
              {{ item1.t }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="w1280">
      <div class="flexs">
        <div style="width:48%">
          <div
            style="color:#045588;font-size:32px;font-weight:600;margin-bottom:24px"
          >
            数据安全与质量证书
          </div>
          <div style="line-height:1.5">
            安全解决方案产品组合包括经 ISO 27001，ISO 27701，ISO9001，GDPR，SOC
            2 类型 II 认证，及 HIPPA
            认证的安全设备、现场服务、安全众包模型和技术解决方案。
          </div>
        </div>
        <div style="width:48%">
          <img style="width:48%;margin-right: 4%;" src="../assets/img/1.png" alt="" />
          <img style="width:48%;" src="../assets/img/5.png" alt="" />
        </div>
      </div>
    </div>
    <div class="card2">
      <div class="title">我们的优势</div>
      <div class="w1280" style="">
        <div class="flexs" style="flex-wrap: wrap;margin:32px 128px">
          <div class="card-ys" v-for="(item, index) in ysList" :key="index">
            <img
              style="width:48px;height:48px;margin-bottom:8px"
              :src="item.img"
              alt=""
            />
            <div class="t1">{{ item.name }}</div>
            <div class="t2">{{ item.content }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="card2">
      <div class="title">数据采集项目服务流程</div>
      <div class="slogan">经验丰富的团队会根据您的需求进行采集方案制定，试采，并严格把控数据质量</div>
      <div class="w1280" style="">
        <img style="width: 100%;" src="../assets/img/sjfw/n3.png" alt="" />
      </div>
    </div>
    <div class="card-footer">
      <div class="t1">全AI流程数据标注服务</div>
      <div class="t2">全类型、多模态、高效率的数据标注服务</div>
      <div class="btns" @click="go('/callMe')">预约试标</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ysList: [
        {
          name: "丰富采集资源遍布全球",
          content:
            "超过20年的采集经验， 众多众包人员，可涵盖超过290种语言和方言",
          img: require("../assets/img/sjfw/e1.svg"),
        },
        {
          name: "自研工具支持高效交付",
          content:
            "自研采集软件可高效整合采集到的数据，同时配备AI辅助质检工具，助力高效率高质量的数据清洗及交付",
          img: require("../assets/img/sjfw/e2.svg"),
        },
        {
          name: "数据安全保证",
          content:
            "我们的安全设备、现场服务、安全众包模型和技术解决方案已经通过 ISO 27001，ISO 27701，ISO9001，GDPR，SOC 2 类型 II 认证，及 HIPPA 认证。",
          img: require("../assets/img/sjfw/e3.svg"),
        },
        {
          name: "先进的项目管理方法论",
          content:
            "有着近30年的采集项目交付经验。针对国内和海外市场的不同数据需求，定制化采集工具，交付流程，质检标准等。为众多五百强以及IT公司提供完整的数据采集标注交付方案，满足不同行业客户对质量，数量，交期以及数据安全等特殊需求。",
          img: require("../assets/img/sjfw/e4.svg"),
        },
      ],
      cardList1: [
        {
          name: "数据存储与传输",
          list: [
            { t: "国安级加密云技术保证数据传输和存储安全" },
            {
              t:
                "业界领先的Appen Secure Workspace可确保在家办公环境达到与安全设备相同的安全级别",
            },
          ],
          img: require("../assets/img/sjfw/x1.svg"),
        },
        {
          name: "项目现场与监管",
          list: [
            { t: "项目现场配置人脸识别和指纹门禁" },
            {
              t:
                "设有加密项目房间，仅授权人员准许进入 Secure Workspace可确保在家办公环境达到与安全设备相同的安全级别",
            },
            { t: "配有24*7值班人员以及无死角摄像头监控现场" },
          ],
          img: require("../assets/img/sjfw/x2.svg"),
        },
        {
          name: "雇员与被采人管控",
          list: [
            { t: "标注人员及供应商签署保密协议" },
            { t: "全体员工办公设备均统一管理" },
          ],
          img: require("../assets/img/sjfw/x3.svg"),
        },
      ],
      cardList: [
        {
          title: "智能驾驶",
          img: require("../assets/img/sjfw/l1.webp"),
          textList: [
            {
              title: "DMS驾驶员行为采集：",
              content:
                "人脸关键点数据采集，疲劳采集，危险动作采集，视线定位采集",
            },
            {
              title: "OMS驾乘舱内动作采集：",
              content:
                "舱内危险动作采集，舱内宠物儿童动作采集，多人娱乐互动采集，手势识别指令采集，车内物品识别采集",
            },
            {
              title: "舱内语音交互数据采集：",
              content: "唤醒词，指令词，ASR，特殊语言采集",
            },
          ],
        },
        {
          title: "医疗健康",
          img: require("../assets/img/sjfw/l2.webp"),
          textList: [
            {
              title: "人体成分参数：",
              content:
                "体脂率、脂肪重量、肌肉量、骨骼肌量、体水分率、骨盐量等数据采集",
            },
            {
              title: "",
              content: "多人种健康数据 & 特定人群数据采集",
            },
            {
              title: "",
              content: "心率采集，血压采集，血糖采集，血氧采集",
            },
            {
              title: "",
              content: "睡眠采集，运动采集",
            },
          ],
        },
        {
          title: "智能化应用场景",
          img: require("../assets/img/sjfw/l3.webp"),
          textList: [
            {
              title: "3D建模：",
              content:
                "针对3D建模需求进行人脸、建筑物、车辆等多方面数据采集，数据清理及模型矫正",
            },
            {
              title: "动作捕捉：",
              content:
                "角色设定，3D建模，模型绑定，动态棚搭建，绑定与采集，以及后期处理",
            },
            {
              title: "数字人：",
              content:
                "根据需求进行模特的服装、妆发、场景定制，快速交付高质量数据",
            },
          ],
        },
        {
          title: "智能家居",
          img: require("../assets/img/sjfw/l4.webp"),
          textList: [
            {
              title: "家居场景图像视频采集：",
              content: "扫地机器人视角采集，智能门锁人脸采集，包裹/外卖采集",
            },
            {
              title: "智能家居语音交互采集：",
              content: "唤醒词采集，声纹识别采集，人机交互语音采集，语音合成",
            },
          ],
        },
      ],
    };
  },
  methods: {
    go(path) {
      this.$router.push(path);
    }
  },
};
</script>
<style lang="scss" scoped>
.sjcj {
  .card1 {
    background-image: linear-gradient(72deg, #7cd0ff54 7.43%, #f0efea 88.33%);
    width: 100%;
    height: 450px;
  }
  .card4 {
    width: 1280px;
    margin: 48px auto;
    text-align: center;
    .item-card2 {
      flex-shrink: 0;
      text-align: center;
      width: 340px;
      margin: 40px 30px;
    }
    .item-card {
      height: 240px;
      flex-shrink: 0;
      padding: 40px 24px;
      background-color: #eceff0;
      border-radius: 8px;
      width: 360px;
      margin-top: 20px;
      text-align: left;
      font-size: 16px;
    }
    .select-tab {
      margin: 30px 0 20px;
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 38px;
      line-height: 38px;
      align-content: center;
      padding: 2px;
      border-radius: 25px;
      border-width: 1px;
      border-style: solid;
      border-color: #000;
      border-image: initial;
      .s-tabs {
        width: 20%;
        height: 38px;
        text-align: center;
        cursor: pointer;
        border-radius: 25px;
      }
      .is-active {
        color: rgb(255, 255, 255);
        background: #045588;
      }
    }
    .card4-t1 {
      color: #045588;
      font-size: 48px;
      font-weight: bold;
    }
    .card4-t2 {
      font-size: 16px;
      width: 680px;
      margin: 24px auto 0;
      line-height: 1.5;
    }
    .card4-t3 {
      font-size: 32px;
      text-align: left;
      margin-bottom: 56px;
      color: #045588;
      font-weight: bold;
    }
    .btns {
      cursor: pointer;
      margin-top: 32px;
      width: 150px;
      background-color: #099fee;
      color: #fff;
      height: 48px;
      line-height: 48px;
      padding: 0 20px;
      border-radius: 8px;
    }
  }
  .card2 {
    width: 1280px;
    margin: 0 auto;
    .card-ys {
      width: 448px;
      height: 208px;
      padding: 24px;
      background-color: #eceff0;
      border-radius: 8px;
      margin-top: 24px;
      .t1 {
        font-size: 20px;
        color: #25282a;
        margin-bottom: 16px;
      }
      .t2 {
        font-size: 16px;
        color: #25282a;
      }
    }
    .card-sx {
      width: 500px;

      margin: 0 0 48px;
      .contents {
        padding: 24px;
        height: 328px;
        background-color: #eceff0;
        border-radius: 0 0 8px 8px;
        .t1 {
          color: #045588;
          font-size: 24px;
          font-weight: 500;
          margin-bottom: 32px;
        }
        .t2 {
          color: #4b4f54;
          font-weight: bold;
          font-size: 16px;
          margin-bottom: 24px;
        }
        .t3 {
          font-weight: normal;
        }
      }
    }
    li {
      line-height: 1.5;
    }
    .t1 {
      color: #045588;
      font-size: 32px;
      margin-bottom: 16px;
      font-weight: 500;
    }
    .title {
      color: #045588;
      text-align: center;
      margin-top: 64px;
      font-weight: 500;
      font-size: 48px;
      margin-bottom: 8px;
    }
    .slogan {
      color: rgb(75, 79, 84);
      font-size: 16px;
      text-align: center;
      line-height: 1.2;
      width: 768px;
      margin: 0 auto 64px;
    }
  }
  .card-footer {
    width: 100%;
    height: 328px;
    background-image: linear-gradient(72deg, #7cd0ff54 7.43%, #f0efea 88.33%);
    .t1 {
      color: rgb(0, 126, 204);
      font-weight: 500;
      font-size: 50px;
      text-align: center;
      padding-top: 60px;
    }
    .t2 {
      text-align: center;
      margin-top: 24px;
    }
    .btns {
      cursor: pointer;
      text-align: center;
      background-image: linear-gradient(
        260.38deg,
        #099fee 3.89%,
        #2247da 143.13%
      );
      width: 96px;
      height: 48px;
      padding: 0 16px;
      line-height: 48px;
      color: #fff;
      margin: 24px auto 0;
      border-radius: 8px;
    }
  }
  .btn1 {
    cursor: pointer;
    width: 120px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #fff;
    background-color: #099fee;
    border-radius: 8px;
  }
  .w1280 {
    width: 1280px;
    margin: 0 auto;
    .t11 {
      color: #045588;
      font-size: 56px;
      font-weight: bold;
      line-height: 84px;
      text-align: center;
    }
    .t22 {
      margin: 32px 256px;
      text-align: center;
      font-size: 20px;
      color: #4b4f54bf;
    }
  }
  .flexs {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
<style></style>
